var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box3-container"},[_c('div',{staticClass:"content"},[_c('div',{style:({width: '100%', height: '100%'}),attrs:{"id":"assetChart"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }